
import React from 'react';

import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';

import { useQuery } from "react-query";

import theme from 'theme';

import { fetchLitigesAdministration } from 'utils/ts-queries';
import { ApiLitige } from 'types/apiReturns';
import { LitigeGestionEtatEnum } from "types/enums";


import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TablePagination from '@mui/material/TablePagination';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

// Icons
import DateRangeIcon from '@mui/icons-material/DateRange';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import DescriptionIcon from '@mui/icons-material/Description';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import PersonIcon from '@mui/icons-material/Person';
import ClearIcon from '@mui/icons-material/Clear';
import DataObjectIcon from '@mui/icons-material/DataObject';
import InputAdornment from '@mui/material/InputAdornment';

import JsonViewerDialog from 'components/Shared/JsonViewerDialog';
import { fetchLitigeMessageJson } from 'utils/ts-queries';


import TriStateFilter from 'components/Shared/TriStateFilter';

import Datetime from 'components/Shared/Datetime';

import GeswebLink from 'components/Shared/GeswebLink'
import MultipleItemsBadgeAndPopover from 'components/Shared/MultipleItemsBadgeAndPopover';

import RelancerIntegrationLitige from  './RelancerIntegrationLitige'
import RelancerCreationDossier from  './RelancerCreationDossier'
import LitigeCanalIcon from 'components/Shared/LitigeCanalIcon';

const etatLabel = (etat: number) => {
    switch (etat) {
        case LitigeGestionEtatEnum.Ouvert: return 'Ouvert';
        case LitigeGestionEtatEnum.Clos: return 'Clos';
        case LitigeGestionEtatEnum.EnAttenteDePaiement: return 'En attente de paiement';
        default: return '';
    }
};

const etatColor = (etat: number) => {
    switch (etat) {
        case LitigeGestionEtatEnum.Ouvert: return '#4caf50';
        case LitigeGestionEtatEnum.Clos: return '#f44336';
        case LitigeGestionEtatEnum.EnAttenteDePaiement: return '#ff9800';
        default: return '#9e9e9e';
    }
};

function LitigeRow(props : {litige: ApiLitige})
{
    const { litige } = props;

    const [open, setOpen] = React.useState(false);
    const [jsonDialogOpen, setJsonDialogOpen] = React.useState(false);
    const [jsonContent, setJsonContent] = React.useState<string | null>(null);

    const handleOpenJsonDialog = async () => {
        setJsonDialogOpen(true);
        setJsonContent(null);
        const result = await fetchLitigeMessageJson(litige.id);
        setJsonContent(result.messageJson);
    };

    const handleCloseJsonDialog = () => {
        setJsonDialogOpen(false);
    };

    return (

        <>

        <TableRow hover sx={{ '& > *': { borderBottom: 'unset' } }}>

            <TableCell>
                <GeswebLink cle={litige.cle} structure='litige' mode='button' label={litige.cle} environment={null} />

                <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => setOpen(!open)}
                >
                    {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
            </TableCell>

            <TableCell>
                <span style={{
                    padding: '4px 8px',
                    borderRadius: '4px',
                    backgroundColor: etatColor(litige.etat),
                    color: 'white',
                    fontSize: '0.8rem',
                    fontWeight: 'bold',
                    whiteSpace: 'nowrap'
                }}>
                    {etatLabel(litige.etat)}
                </span>
            </TableCell>

            <TableCell>
                <Link
                    to={`/reclamations/${litige.reclamationId}`}
                    underline="hover"
                    component={RouterLink}
                    sx={{ fontWeight: 'bold' }}
                >
                    {litige.reclamationId}
                </Link>
            </TableCell>

            <TableCell>
                <GeswebLink cle={litige.codeClientFacture} structure='client' mode='button' label={litige.codeClientFacture} environment={null} />
            </TableCell>
            <TableCell>
                <GeswebLink cle={litige.facture} structure='facture' mode='button' label={litige.facture} environment={null} />
            </TableCell>
            <TableCell>
                <MultipleItemsBadgeAndPopover
                    label={null}
                    title={`Bons de livraison du litige ${litige.cle}`}
                    items={litige.bonsLivraison}
                    display={(x: object | string) => {return (x as string);}}
                    badge={true}
                />
            </TableCell>
            <TableCell>{litige.libelleOrigine}</TableCell>
            <TableCell>
                <Datetime datetime={litige.dateModification} />
            </TableCell>
            <TableCell>

            {litige.erreur && litige.erreur.includes("ntégration du numéro de dossier sur le litige") && (
                <span>à l'intégration</span>
            )}
            {litige.erreur && litige.erreur.includes("réation du dossier") && (
                <span>à la création</span>
            )}
            </TableCell>


            <TableCell>
                <Stack spacing={1}>
                    {/* Un dossier existe déjà : quelle que soit l'erreur (intégration, ou timeout après un commit
                        passé côté serveur), il ne faut jamais recréer le dossier, seulement rejouer l'intégration. */}
                    {litige.erreur && litige.reclamationId !== null && (
                        <RelancerIntegrationLitige reclamationId={litige.reclamationId} />
                    )}
                    {litige.erreur && litige.reclamationId === null && (
                        <RelancerCreationDossier litigeId={litige.id} factureFacultative={false} />
                    )}
                    {litige.erreur && litige.reclamationId === null && litige.erreur.includes("facture inconnue") && (
                        <RelancerCreationDossier litigeId={litige.id} factureFacultative={true} />
                    )}
                </Stack>
            </TableCell>

        </TableRow>


        <TableRow >

            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>

                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box sx={{ margin: 1, display:'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: '10px'}}>

                        {litige.erreur && (
                            <Box sx={{ gridColumnStart: 1, gridColumnEnd: 13, gridRowStart: 1, gridRowEnd:2, backgroundColor: '#f44336', padding: 1, color : 'white', fontWeight: 'bold'}}>
                                {litige.erreur}
                            </Box>
                        )}

                        <Box sx={{ gridColumnStart: 1, gridColumnEnd: 13, gridRowStart: 2, gridRowEnd: 3, padding: 1, backgroundColor: '#e8eaf6', borderRadius: 1, display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap' }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                                <PersonIcon fontSize="small" sx={{ mr: 0.5 }} />
                                Intervenants
                            </Typography>
                            {litige.preneur && (
                                <Typography variant="body2"><strong>Preneur :</strong> {litige.preneur}</Typography>
                            )}
                            {litige.responsable && (
                                <Typography variant="body2"><strong>Responsable :</strong> {litige.responsable}</Typography>
                            )}
                            {litige.utilisateurRelaisLitige && (
                                <Typography variant="body2"><strong>Gestionnaire :</strong> {litige.utilisateurRelaisLitige}</Typography>
                            )}
                            {litige.representant && (
                                <Typography variant="body2"><strong>Représentant :</strong> {litige.representant}</Typography>
                            )}
                            {litige.canal !== null && (
                                <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <strong>Canal :</strong> <LitigeCanalIcon canal={litige.canal}/>
                                </Typography>
                            )}
                        </Box>

                        <Box sx={{ margin: 1, padding: 1, gridColumnStart: 1, gridColumnEnd: 7, gridRowStart: 3, gridRowEnd:4, backgroundColor: '#f0f0f0'}}>

                            <Typography variant="subtitle1" sx={{ color : theme.palette.primary.light, fontWeight: 'bold', mb: 1 }}>
                                Ouverture
                            </Typography>
                            {litige.dateDebut && (
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    <DateRangeIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} />
                                    <Datetime datetime={litige.dateDebut} />
                                </Typography>
                            )}
                            {litige.libelleOrigine && (
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    <HelpOutlineIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} />
                                    {litige.libelleOrigine} {litige.origine && `(${litige.origine})`}
                                </Typography>
                            )}
                            {litige.commentaire && (
                                <Typography variant="body2" sx={{ mb: 1, whiteSpace: "pre-wrap" }}>
                                    <DescriptionIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} />
                                    {litige.commentaire}
                                </Typography>
                            )}

                        </Box>

                        <Box sx={{ margin: 1, padding: 1,  gridColumnStart: 7, gridColumnEnd: 13, gridRowStart: 3, gridRowEnd:4, backgroundColor: '#f0f0f0'}}>

                            <Typography variant="subtitle1" sx={{ color : theme.palette.primary.light, fontWeight: 'bold', mb: 1 }}>
                            Clôture
                            </Typography>
                            {litige.dateCloture && (
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                <DateRangeIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} />
                                <Datetime datetime={litige.dateCloture} />
                            </Typography>
                            )}
                            {litige.libelleCloture && (
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                {litige.libelleCloture} {litige.cloture && `(${litige.cloture})`}
                            </Typography>
                            )}
                            {litige.commentaireCloture && (
                            <Typography variant="body2" sx={{ mb: 1, whiteSpace: "pre-wrap" }}>
                                <DescriptionIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} />
                                {litige.commentaireCloture}
                            </Typography>
                            )}


                        </Box>


                        <Box sx={{ gridColumnStart: 1, gridColumnEnd: 4, gridRowStart: 4, gridRowEnd:5}}>
                            Création : <Datetime withTooltip withTime datetime={litige.dateCreation} />
                        </Box>
                        <Box sx={{ gridColumnStart: 4, gridColumnEnd: 7, gridRowStart: 4, gridRowEnd:5}}>
                            Intégration : <Datetime withTooltip withTime datetime={litige.dateIntegration} />
                        </Box>
                        <Box sx={{ gridColumnStart: 7, gridColumnEnd: 10, gridRowStart: 4, gridRowEnd:5}}>
                            Modification : <Datetime withTooltip withTime datetime={litige.dateModification} />
                        </Box>
                        <Box sx={{ gridColumnStart: 10, gridColumnEnd: 13, gridRowStart: 4, gridRowEnd:5, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1}}>
                            <GeswebLink cle={litige.facture} structure='facture' mode='link' label={"Voir sur Gesweb (PROD)"} environment={'PROD'} />
                            <Button
                                variant="outlined"
                                size="small"
                                startIcon={<DataObjectIcon />}
                                onClick={handleOpenJsonDialog}
                            >
                                JSON
                            </Button>
                        </Box>


                    </Box>
                </Collapse>

            </TableCell>

        </TableRow>

        <JsonViewerDialog
            open={jsonDialogOpen}
            onClose={handleCloseJsonDialog}
            title={`Messages JSON - Litige ${litige.cle}`}
            jsonEntries={[
                { label: 'Litige', value: jsonContent },
            ]}
        />

        </>
    );
}

const SortableHeader = (props: { label: string, colonne: string, triPar: string | null, triAscendant: boolean, onClick: (col: string) => void, sx?: object }) => {
    const { label, colonne, triPar, triAscendant, onClick, sx } = props;
    const isActive = triPar === colonne;
    return (
        <TableCell
            sx={{ backgroundColor: 'lightslategrey', cursor: 'pointer', ...sx }}
            onClick={() => onClick(colonne)}
        >
            {label}{' '}
            <span style={{
                color: isActive ? theme.palette.warning.main : 'gray',
                marginLeft: '4px'
            }}>
                {isActive ? (triAscendant ? '▲' : '▼') : '▲'}
            </span>
        </TableCell>
    );
};

const AdministrationLitiges = () => {

    const [page, setPage] = React.useState(0);
    const [nbParPage, setNbParPage] = React.useState<number>(10);

    const [filtreCle, setFiltreCle] = React.useState('');
    const [filtreErreur, setFiltreErreur] = React.useState<boolean | null>(true);
    const [filtreEtat, setFiltreEtat] = React.useState<number | null>(null);
    const [filtreClient, setFiltreClient] = React.useState('');

    const [triPar, setTriPar] = React.useState<string | null>(null);
    const [triAscendant, setTriAscendant] = React.useState<boolean>(true);

    const handleSort = (colonne: string) => {
        if (triPar === colonne) {
            if (!triAscendant) {
                setTriPar(null);
            } else {
                setTriAscendant(false);
            }
        } else {
            setTriPar(colonne);
            setTriAscendant(true);
        }
    };

    const { isLoading, isError, data } =
        useQuery({
            queryKey: [
                'litiges',
                page,
                nbParPage,
                filtreCle,
                filtreErreur,
                filtreEtat,
                filtreClient,
                triPar,
                triAscendant
            ],
            queryFn: () => fetchLitigesAdministration({
                page,
                nbParPage,
                filtreCle: filtreCle,
                filtreErreur: filtreErreur,
                filtreEtat: filtreEtat,
                filtreClient: filtreClient,
                triPar: triPar || undefined,
                triAscendant: triAscendant
            }),
            keepPreviousData: false,
        })




    const handleChangePage = (_event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        setPage(newPage);
    };


    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNbParPage(+event.target.value);
        setPage(0);
    };



    React.useEffect(() => {
            setPage(0);
        },
        [filtreCle, filtreErreur, filtreEtat, filtreClient, triPar, triAscendant]
    );



    return (
        <>
            <Typography gutterBottom variant="h5">
                Visualisation des litiges client
            </Typography>


            <Paper>

                <TableContainer sx={{ maxHeight: 'calc(100vh - 152px)' }}>
                    <Table stickyHeader aria-label="sticky table" sx={{ width: '100%' }} size='small'>
                        <TableHead
                            sx={{
                                position: "sticky",
                                top: 0,
                                zIndex: 2,
                            }}
                        >
                            <TableRow>
                                <SortableHeader label="Clé" colonne="cle" triPar={triPar} triAscendant={triAscendant} onClick={handleSort} sx={{ width: '140px' }} />

                                <TableCell sx={{ backgroundColor: 'lightslategrey', width: '130px' }}>État</TableCell>

                                <TableCell sx={{ backgroundColor: 'lightslategrey', width: '100px' }}>Dossier</TableCell>

                                <TableCell sx={{ backgroundColor: 'lightslategrey', width: '150px' }}>Client</TableCell>
                                <TableCell sx={{ backgroundColor: 'lightslategrey', width: '160px' }}>Facture</TableCell>
                                <TableCell sx={{ backgroundColor: 'lightslategrey', width: '100px' }}>Bon(s) de livraison</TableCell>

                                <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Origine</TableCell>

                                <SortableHeader label="Modification" colonne="dateModification" triPar={triPar} triAscendant={triAscendant} onClick={handleSort} />

                                <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Erreur</TableCell>

                                <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Action</TableCell>

                            </TableRow>
                            <TableRow sx={{margin: 0}}>
                                <TableCell>
                                    <TextField
                                        value={filtreCle}
                                        onChange={e => { setFiltreCle(e.target.value) }}
                                        size='small'
                                    >
                                    </TextField>
                                </TableCell>
                                <TableCell>
                                    <Select
                                        value={filtreEtat === null ? '' : filtreEtat}
                                        onChange={e => { setFiltreEtat(e.target.value === '' ? null : e.target.value as number) }}
                                        size='small'
                                        displayEmpty
                                        sx={{ width: 120 }}
                                    >
                                        <MenuItem value="">Tous</MenuItem>
                                        <MenuItem value={LitigeGestionEtatEnum.Ouvert}>Ouvert</MenuItem>
                                        <MenuItem value={LitigeGestionEtatEnum.EnAttenteDePaiement}>En attente</MenuItem>
                                        <MenuItem value={LitigeGestionEtatEnum.Clos}>Clos</MenuItem>
                                    </Select>
                                </TableCell>
                                <TableCell></TableCell>
                                <TableCell>
                                    <TextField
                                        value={filtreClient}
                                        onChange={e => { setFiltreClient(e.target.value) }}
                                        size='small'
                                        sx={{ width: 140 }}
                                        InputProps={{
                                            endAdornment: filtreClient && (
                                                <InputAdornment position="end">
                                                    <IconButton size="small" onClick={() => setFiltreClient('')}>
                                                        <ClearIcon fontSize="small" />
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>

                                <TableCell>
                                    <Box sx={{minWidth: 60}}>
                                        <TriStateFilter
                                            value={filtreErreur}
                                            onChange={(newValue: boolean | null) => { setFiltreErreur(newValue) }}
                                        />
                                    </Box>
                                </TableCell>

                                <TableCell></TableCell>


                            </TableRow>
                        </TableHead>


                        {isLoading ? (
                            <div>Chargement...</div>
                        ) : isError ? (
                            <div>Erreur: Échec du chargement</div>
                        ) : data !== undefined ? (

                            <TableBody>
                                {data.litiges
                                    .map((litige) => {

                                        return (
                                            <LitigeRow key={litige.id} litige={litige} />
                                        );
                                    })}
                            </TableBody>

                        ) : (
                            <span></span>
                        )}


                    </Table>


                    {data !== undefined ? (
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={data.nbFiltres}
                            rowsPerPage={nbParPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    ) : (
                        <span></span>
                    )}


                </TableContainer>

            </Paper>


        </>

        );

};


export default AdministrationLitiges;
